import { ClientTrackingView } from '../../Views/Home/ClientTrackingView';
import ClientTrackingTabs from '../../Views/Home/ClientTrackingView/ClientTrackingTabs';
export const ClientTrackingRoutes = [
  {
    path: '/view',
    name: 'ClientsTracking:clients-tracking',
    component: ClientTrackingTabs,
    layout: '/home/clients-tracking',
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ClientsTracking:clients-tracking',
        isDisabled: true,
        route: '/home/clients-tracking/view',
        groupName: 'partner-hub',
      },
    ],
  },
];
